import { container } from "@/inversify.config";
import { CatalogOperationVue } from "fs-pb-vue2/vueModels/operations/CatalogOperationVue";
import { OperationPropertyModel } from "fs-pb-vue2/models/operations/operationPropertyModel";
import { Dictionary } from "fs-pb-vue2/data/types";
import { CatalogOperationModel } from "fs-pb-vue2/models/operations/catalogOperationModel";
import i18n from "@/i18n";

/**Модель представления операции */
export class CatalogOperationVueFS extends CatalogOperationVue {
	initDefaultContractToValue(): void {
    const contractItem: OperationPropertyModel = this.OperationModel.Properties.find((prop: OperationPropertyModel) => prop.Declaration.Name === 'contract');
    if (this.$route.name === 'Operation' && this.operInitType == 0 && contractItem && contractItem.Value.Key !== this.personStore.personInfo.Data.DefaultInAccount) {
      const contractToItem: OperationPropertyModel = this.OperationModel.Properties.find((prop: OperationPropertyModel) => prop.Declaration.Name === 'contractTo');
      if (contractToItem && this.personStore.personInfo.Data.DefaultInAccount && !this.$route.query.contractTo) {
        contractToItem.Value = contractToItem.Values.find((val: any) => val.Key === this.personStore.personInfo.Data.DefaultInAccount);
      }
			if (contractItem && this.personStore.personInfo.Data.DefaultInAccount && this.operId.toString() === this.configStore.apiData.OperationCodeOfMe2MeOperation) {
        contractItem.Value = contractItem.Values.find((val: any) => val.Key === this.personStore.personInfo.Data.DefaultInAccount);
			}
    }
  }

	/**Метод для выполнения после успешного проведения */
	async afterExecute(): Promise<void> {
	// await this.destroyForm();

	this.appStore.setLoading(true);

	this.successDetails = await this.detailsService.getOperationDetails({ Id: this.OperationModel.OperationId, ReferenceId: "" });
	this.appStore.setLoading(false);
	}

	async initOperation(): Promise<void> {
    this.loading = true;
    let addInitData: Dictionary<string | string[]> = {};
    for (const i in this.$route.query) {
      addInitData[i] = this.$route.query[i];
    }
    if (Object.keys(addInitData).length === 0 && !!this.addInitData)
      addInitData = this.addInitData;

    this.OperationModel = (await this.service.init(
      this.operId,
      this.operInitType,
      addInitData
    )) as CatalogOperationModel;

    this.initDefaultContractToValue();

    this.loading = false;
  }
}